module.exports = __webpack_public_path__ + "static/media/bailo-2.890d225c.jpg";